import {
  FETCH_EVENTS_START,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  FETCH_SINGLE_EVENT_START,
  FETCH_SINGLE_EVENT_SUCCESS,
  FETCH_SINGLE_EVENT_FAILURE,
  CREATE_CHECKOUT_SESSION_START,
  CREATE_CHECKOUT_SESSION_SUCCESS,
  CREATE_CHECKOUT_SESSION_FAILURE,
  SET_BOOKING_PAYMENT_SUCCESS_START,
  SET_BOOKING_PAYMENT_SUCCESS_SUCCESS,
  SET_BOOKING_PAYMENT_SUCCESS_FAILURE,
  SET_BOOKING_PAYMENT_FAILED_START,
  SET_BOOKING_PAYMENT_FAILED_SUCCESS,
  SET_BOOKING_PAYMENT_FAILED_FAILURE,
  FETCH_MY_EVENT_BOOKINGS_START,
  FETCH_MY_EVENT_BOOKINGS_FAILURE,
  FETCH_MY_EVENT_BOOKINGS_SUCCESS
} from "./ActionConstant";

export function fetchEventsStart(data) {
  return {
    type: FETCH_EVENTS_START,
    data,
  };
}

export function fetchEventsSuccess(data) {
  return {
    type: FETCH_EVENTS_SUCCESS,
    data,
  };
}

export function fetchEventsFailure(error) {
  return {
    type: FETCH_EVENTS_FAILURE,
    error,
  };
}

export function fetchSingleEventStart(data) {
  return {
    type: FETCH_SINGLE_EVENT_START,
    data,
  };
}

export function fetchSingleEventSuccess(data) {
  return {
    type: FETCH_SINGLE_EVENT_SUCCESS,
    data,
  };
}

export function fetchSingleEventFailure(error) {
  return {
    type: FETCH_SINGLE_EVENT_FAILURE,
    error,
  };
}

export function createPaymentIntentStart(data) {
  return {
    type: CREATE_CHECKOUT_SESSION_START,
    data,
  };
}

export function createPaymentIntentSuccess(data) {
  return {
    type: CREATE_CHECKOUT_SESSION_SUCCESS,
    data,
  };
}

export function createPaymentIntentFailure(error) {
  return {
    type: CREATE_CHECKOUT_SESSION_FAILURE,
    error,
  };
}

export function setBookingPaymentSuccStart(data) {
  return {
    type: SET_BOOKING_PAYMENT_SUCCESS_START,
    data,
  };
}

export function setBookingPaymentSuccSuccess(data) {
  return {
    type: SET_BOOKING_PAYMENT_SUCCESS_SUCCESS,
    data,
  };
}

export function setBookingPaymentSuccFailure(error) {
  return {
    type: SET_BOOKING_PAYMENT_SUCCESS_FAILURE,
    error,
  };
}

export function setBookingPaymentFailedStart(data) {
  return {
    type: SET_BOOKING_PAYMENT_FAILED_START,
    data,
  };
}

export function setBookingPaymentFailedSuccess(data) {
  return {
    type: SET_BOOKING_PAYMENT_FAILED_SUCCESS,
    data,
  };
}

export function setBookingPaymentFailedFailure(error) {
  return {
    type: SET_BOOKING_PAYMENT_FAILED_FAILURE,
    error,
  };
}

export function fetchMyEventBookingsStart(data) {
  return {
    type: FETCH_MY_EVENT_BOOKINGS_START,
    data,
  };
}

export function fetchMyEventBookingsSuccess(data) {
  return {
    type: FETCH_MY_EVENT_BOOKINGS_SUCCESS,
    data,
  };
}

export function fetchMyEventBookingsFailure(error) {
  return {
    type: FETCH_MY_EVENT_BOOKINGS_FAILURE,
    error,
  };
}
